import {createSlice} from '@reduxjs/toolkit';
import set from 'lodash/set';

const initialState = {
  items: [],
};

const slice = createSlice({
  name: 'products',
  initialState,
  reducers: {},
  extraReducers: {
    '@flower/products/update': (state, action) =>
      set(state, action.payload.id, action.payload.value),
  },
});

export const actions = slice.actions;
export default slice.reducer;
